module.exports = __webpack_public_path__ + "static/media/geogames_lists.d7fb4f03.png";